import React from 'react';
import ArrowLeftThin from '../Icon/ArrowLeftThin';
import './assets/styles/drawer-styles.scss';
import logo from '../../assets/images/footer-logo.svg';
import { Link } from '@reach/router';

function Drawer({ visible, onClose = () => {} }) {
  return (
    <div className={`drawer-container ${visible ? 'open' : 'closed'}`}>
      <div className="arrow-right-container" onClick={onClose}>
        <ArrowLeftThin />
      </div>
      <div className="menu-drawer">
        <div className="menu-links">
          <img src={logo} alt="" height={90} draggable={false} />
          <Link to="courses" onClick={onClose}>
            Courses
          </Link>
          <Link to="education_partners" onClick={onClose}>
            Educational Partners
          </Link>
          {/* <Link to="//apptitude.xyz/events/" onClick={onClose}>
            Events
          </Link> */}
        </div>
        <div className="menu-action-btn">
          <a href="//apptitude.xyz/login/" className="btn">Log In</a>
          <a href="//apptitude.xyz/signup/" className="btn">Sign Up</a>
        </div>
      </div>
    </div>
  );
}

export default Drawer;
